// extracted by mini-css-extract-plugin
export default {"date-container":"wJMJC7","dateContainer":"wJMJC7"};